
import { SQLCourse } from './types';
import { phase6Modules } from './phase6Modules';

export const SQL_PHASE6_COURSE: SQLCourse = {
  id: "sql-phase6-industry-specialization",
  title: "SQL for Industry Specialization",
  description: "Master SQL for specific industries including Healthcare, Financial Services, E-commerce, Manufacturing, Media & Entertainment, and Government sectors with real-world applications and compliance requirements.",
  level: "expert",
  durationHours: 24,
  tags: ["Industry Specialization", "Healthcare", "Finance", "E-commerce", "Manufacturing", "Government", "Compliance", "Real-World Applications"],
  imageSrc: "/placeholder.svg",
  image: "/placeholder.svg",
  modules: phase6Modules,
  totalDuration: "12 hours",
  requirements: [
    "Completion of Future SQL Technologies course",
    "Industry domain knowledge (recommended)",
    "Advanced SQL proficiency",
    "Understanding of data compliance requirements"
  ]
};
